<div fxLayout="column" fxLayoutAlign="center center">
  <span class="material-symbols-outlined ">
    <mat-icon class="ico">sms_failed </mat-icon>
  </span>
    <span class="tipoLetra">{{'MODALES.MODAL_SECC_CONF_VOIC'| translate }}</span>
    <mat-checkbox class="example-margin noMos" [(ngModel)]="NomostrarMo">{{'MODALES.ACCIONES.INFORMATIVO'| translate }}</mat-checkbox>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <button mat-raised-button color="accent" class="mt-20" (click)="salir(NomostrarMo)">
    <!-- {{'HISTORIAL_MAILS.MODAL.BOTONES.BACK' | translate}} -->
    {{'MODALES.ACCIONES.aceptar'| translate }}
  </button>
</div>
